/* global axios */
import ApiClient from './ApiClient';

class Financial extends ApiClient {
  constructor() {
    super('financial', { accountScoped: true });
  }

  cancel(reason, { cancelAccount = false } = {}) {
    return axios.delete(this.url, {
      data: { reason, cancel_account: cancelAccount },
    });
  }

  openPayments() {
    return axios.get(`${this.url}/open_payments`);
  }

  pix(paymentId) {
    return axios.get(
      `${this.url}/payments/${encodeURIComponent(paymentId)}/pix`
    );
  }

  boleto(paymentId) {
    return axios.get(
      `${this.url}/payments/${encodeURIComponent(paymentId)}/boleto`
    );
  }

  payWithCreditCard(paymentId, creditCard) {
    return axios.post(
      `${this.url}/payments/${encodeURIComponent(paymentId)}/credit_card`,
      { credit_card: creditCard }
    );
  }
}

export default new Financial();
